"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'enphase-Icon': {
    color: '#FFFFFF'
  },
  'enphase-AddDeduct': {
    text: '#FFFFFF',
    background: 'rgba(1, 180, 222,0.5)',
    'background-hover': 'rgba(1, 180, 222)',
    fill: 'rgba(1, 180, 222)',
    'fill-hover': '#fdf1e8',
    'AddDeduct-fill-hover': 'rgba(1, 180, 222,0.5)'
  },
  'enphase-AddressBook': {
    'icon-button-hover': 'rgb(74, 74, 74, 0.08)',
    'mapArea-background': '#000000'
  },
  'enphase-Backdrop': {
    'background-color': 'rgba(0, 0, 0, 0.5)'
  },
  'enphase-Badge': {
    'text-color': '#ffffff',
    'box-shadow': '#ffffff',
    default: '#007aff',
    success: '#007aff',
    processing: '#007aff',
    error: '#007aff',
    warning: '#007aff'
  },
  'enphase-Button': {
    primary: 'rgb(1, 180, 222);',
    'primary-text-color': 'rgb(255, 255, 255);',
    'primary-border': 'none',
    'primary-hover': 'rgb(1, 180, 222)',
    'primary-hover-text-color': '#ffffff',
    'primary-hover-border': 'none',
    'primary-active': 'rgba(255, 255, 255, 0.6)',
    'primary-active-text-color': '#0A0802',
    'primary-active-border': 'none',
    'primary-focus': 'rgb(1, 180, 222)',
    'primary-focus-text-color': '#ffffff',
    'primary-focus-border': '#6a320e',
    'primary-disabled': 'rgba(255, 255, 255, 0.2)',
    'primary-disabled-text-color': '#0A0802',
    'primary-disabled-border': 'none',
    secondary: 'rgb(38, 38, 39)',
    'secondary-text-color': '#FFFFFF',
    'secondary-border': '#c7c8ca',
    'secondary-hover': '#2f2f2f',
    'secondary-hover-text-color': '#FFFFFF',
    'secondary-hover-border': '#c7c8ca',
    'secondary-active': 'rgba(255, 255, 255, 0.1)',
    'secondary-active-text-color': 'rgba(255, 255, 255, 0.6)',
    'secondary-active-border': 'none',
    'secondary-focus': '#f4f4f4',
    'secondary-focus-text-color': '#4a4a4a',
    'secondary-focus-border': '#c7c7ca',
    'secondary-disabled': 'rgba(255, 255, 255, 0.1)',
    'secondary-disabled-text-color': 'rgba(255, 255, 255, 0.2)',
    'secondary-disabled-border': 'none',
    outlined: 'rgb(38, 38, 39)',
    'outlined-text-color': 'rgb(1, 180, 222)',
    'outlined-border': 'rgb(1, 180, 222)',
    'outlined-hover': 'rgba(1, 180, 222,0.5)',
    'outlined-hover-text-color': 'rgb(1, 180, 222)',
    'outlined-hover-border': 'rgb(1, 180, 222)',
    'outlined-active': '#e6faff',
    'outlined-active-text-color': 'rgb(1, 180, 222)',
    'outlined-active-border': 'rgb(1, 180, 222)',
    'outlined-focus': '#e6faff',
    'outlined-focus-text-color': 'rgb(1, 180, 222)',
    'outlined-focus-border': 'rgb(1, 180, 222)',
    'outlined-disabled': '#ccf5ff',
    'outlined-disabled-text-color': '#ccf5ff',
    'outlined-disabled-border': '#ccf5ff',
    'text-color': 'rgb(1, 180, 222)',
    'text-color-hover': 'rgb(1, 180, 222)',
    'text-color-disabled': '#003e4c'
  },
  'enphase-Card': {
    'background-color': '#333',
    'box-shadow': 'none',
    color: '#fff'
  },
  'enphase-Checkbox': {
    outline: '#fff',
    'outline-disabled': '#a3a3a3',
    fill: '#01b5de',
    'fill-background-color': '#fff',
    'fill-disabled': 'rgba(255, 255, 255, 0.2)',
    'fill-disabled-background-color': '#0A0802',
    'text-color': '#fff',
    'text-color-disabled': '#FFFFFF',
    'border-color': '#fff'
  },
  'enphase-Chip': {
    primary: 'rgb(1, 180, 222);',
    'text-color': '#ffffff'
  },
  'enphase-Datepicker': {
    'background-color': 'rgb(38, 38, 39)',
    'range-select': '#f37420bf',
    'box-shadow': '#212b3614',
    'header-text-color': '#FFF',
    placeholder: '#4a4a4a',
    'muted-text-color': '#4a4a4a',
    primary: 'rgba(1, 180, 222)',
    'unit-text-color': '#FFFFFF',
    'unit-text-hover': '#FFFFFF',
    'unit-text-hover-background-color': 'rgba(1, 180, 222,0.5)',
    disabled: '#c7c8ca',
    selected: '#ffffff',
    'input-label': '#929292',
    'border-color': '#b6b6b6',
    'input-background-color': 'none',
    'input-text-color': 'none',
    'track-color': 'rgba(255, 255, 255, 0.2)',
    'track-color-on': '#56BB5F',
    'thumb-color': '#FFFFFF',
    'thumb-shadow': 'none',
    'thumb-color-on': '#FFFFFF',
    'text-color': '#FFFFFF',
    'text-color-disabled': 'rgba(255, 255, 255, 0.6)'
  },
  'enphase-Divider': {
    primary: '#B2C7D5'
  },
  'enphase-Drawer': {
    'backdrop-color': 'rgba(10, 8, 2, 0.6)',
    'background-color': '#242424',
    'box-shadow': 'none',
    'border-color': 'rgba(255, 255, 255, 0.2)'
  },
  'enphase-Dropdown': {
    'text-color': 'rgba(0, 0, 0, 0.85)'
  },
  'enphase-IconButton': {
    color: '#333',
    border: '#c7c8ca',
    'hover-background-color': '#2f2f2f',
    'icon-path-color': '#efeded'
  },
  'enphase-Info': {
    'text-color': '#4a4a4a'
  },
  'enphase-Input': {
    standard: '#FFFFFF',
    'standard-background-color': 'rgb(38, 38, 39)',
    'standard-text-color': '#FFFFFF',
    'standard-placeholder': 'rgba(255, 255, 255, 0.6)',
    'standard-label-text-color': '#FFFFFF',
    'standard-label-active-text-color': 'rgba(255, 255, 255, 0.6)',
    'standard-error-color': '#ff5959',
    'error-color': '#ff5959',
    'standard-disabled-text-color': 'rgba(255, 255, 255, 0.6)',
    'standard-border': 'rgba(255, 255, 255, 0.6)',
    'standard-helper-text-color': 'rgba(255, 255, 255, 0.6)',
    outlined: 'rgb(1, 180, 222)',
    'outlined-background-color': 'rgb(38, 38, 39)',
    'outlined-text-color': '#FFFFFF',
    'outlined-placeholder': 'rgba(255, 255, 255, 0.6)',
    'outlined-label-text-color': '#FFFFFF',
    'outlined-label-active-text-color': 'rgba(255, 255, 255, 0.6)',
    'outlined-error-color': '#ff5959',
    'outlined-disabled-text-color': 'rgba(255, 255, 255, 0.6)',
    'outlined-border': 'rgba(255, 255, 255, 0.6)',
    'outlined-helper-text-color': 'rgba(255, 255, 255, 0.6)'
  },
  'enphase-Link': {
    primary: 'rgb(1, 180, 222)'
  },
  'enphase-Loader': {
    primary: 'rgb(1, 180, 222)'
  },
  'enphase-Menu': {
    'background-color': 'rgb(38, 38, 39)',
    'box-shadow-right-color': 'rgba(0, 0, 0, 0.12)',
    'box-shadow-bottom-color': 'rgba(0, 0, 0, 0.08)',
    'box-shadow-left-color': 'rgba(0, 0, 0, 0.05)',
    'text-color': 'rgba(0, 0, 0, 0.85)',
    'hover-background-color': 'rgb(74, 74, 74)'
  },
  'enphase-Modal': {
    'backdrop-color': 'rgba(10, 8, 2, 0.6)',
    'background-color': '#242424',
    'box-shadow': 'none',
    'border-color': 'transparent',
    'title-color': '#FFFFFF',
    color: '#fff'
  },
  'enphase-Pagination': {
    'background-color': 'rgb(38, 38, 39)',
    'hover-background-color': 'rgb(74, 74, 74)',
    'text-color': '#fff',
    'selected-background-color': 'rgb(74, 74, 74)'
  },
  'enphase-PhoneInput': {
    'background-color': 'rgb(38,38,39)',
    error: 'rgb(1, 180, 222)',
    'country-list-hover-background-color': 'rgba(0, 0, 0, 0.35)',
    'country-list-highlight-background-color': 'rgba(0, 0, 0, 0.35)',
    'country-list-divider': '#4a4a4a',
    'text-color': '#fff',
    'input-color': 'transparent',
    'box-shadow': 'rgba(0, 0, 0, 0.35)'
  },
  'enphase-Popover': {
    'background-color': '#ffffff',
    'box-shadow': 'rgba(0, 0, 0, 0.1)'
  },
  'enphase-Radio': {
    'text-color': '#FFFFFF',
    'text-color-highlight': '#FFFFFF',
    'text-color-disabled': 'rgba(255, 255, 255, 0.6)',
    'fill-visual': '#01b5de',
    'fill-visual-background-color': 'rgb(38, 38, 39)',
    'fill-visual-outline': '#FFFFFF',
    'fill-visual-disabled': 'rgba(255, 255, 255, 0.2)',
    'fill-visual-outline-disabled': 'rgba(255, 255, 255, 0.2)',
    'fill-system': '#01b5de',
    'fill-system-border': '#ccc',
    'fill-system-background-color': '#0A0802',
    'fill-system-outline': '#FFFFFF',
    'fill-system-disabled': 'transparent',
    'fill-system-outline-disabled': 'rgba(255, 255, 255, 0.6)',
    'Radio-fill-system': 'red'
  },
  'enphase-RangeSlider': {
    'background-color': '#000',
    primary: 'rgb(1, 180, 222)',
    'border-color': 'rgb(1, 180, 222)',
    'range-background-color': 'rgba(1, 180, 222,0.5)',
    'border-color2': '#9E9E9E',
    'label-color': '#fff',
    'placeholder-color': '#fff'
  },
  'enphase-Select': {
    border: '#b6b6b6',
    primary: 'rgb(1, 180, 222)',
    error: '#ff5959',
    'option-text-title': '#fff',
    'option-text-title-selected': 'rgb(1, 180, 222)',
    'option-text-title-hover': 'rgba(1, 180, 222,0.5)',
    divider: '#4a4a4a',
    'background-color': 'rgb(38, 38, 39)',
    'placeholder-text': 'rgb(74, 74, 74, 0.6)'
  },
  'enphase-Switch': {
    'track-color': 'hsla(0,0%,71.4%,.3)!important',
    'track-color-on': 'hsla(0,0%,71.4%,.3)!important',
    'thumb-color': '#a2a6a9!important',
    'thumb-shadow': 'none',
    'thumb-color-on': 'rgb(1, 180, 222)',
    'text-color': '#FFFFFF',
    'text-color-disabled': 'rgba(255, 255, 255, 0.6)'
  },
  'enphase-Table': {
    primary: '#335977',
    'background-color': 'rgb(38, 38, 39)',
    'tooltip-background-color': '#000000',
    'tooltip-text-color': '#ffffff',
    'tooltip-border-color': '#000000',
    border: '#e5e5e56b',
    'primary-variant': '#335977',
    'primary-variant-title': '#ffffff',
    'secondary-variant': '#faf1e6',
    'box-shadow': 'rgb(74, 74, 74, 0.3)',
    'action-button-border': 'rgb(74, 74, 74, 0.1)',
    'text-color': '#fff',
    'option-label-hover-background-color': 'rgba(74, 74, 74, 0.08)',
    'header-background-color': '#f6f6f6',
    'selected-td': '#fdf1e8',
    'fixed-col-shadow': 'rgba(0, 0, 0, 0.15)'
  },
  'enphase-Tabs': {
    primary: 'rgb(1, 180, 222)',
    'background-color': '##929292',
    'border-color': '#c7c8ca',
    'fancy-background': 'transparent',
    'fancy-text-color': '#637b8b',
    'hover-fancy-text-color': 'rgb(1, 180, 222)',
    'secondary-hover': '#929292',
    'icon-section-background-color': 'rgba(1, 180, 222,0.5)',
    'fancy-hover': 'rgba(1, 180, 222,0.5)'
  },
  'enphase-Timepicker': {
    primary: 'rgb(1, 180, 222)',
    'time-text-color': '#f8f8ff',
    border: 'rgb(74, 74, 74, 0.1)',
    'box-shadow': 'rgb(74, 74, 74, 0.3)',
    'input-border': '#b6b6b6',
    'label-text-color': '#929292',
    'hover-background-color': 'rgba(1, 180, 222,0.5)',
    'selected-text-color': '#ffffff',
    'background-color': 'rgb(38, 38, 39)',
    'input-text-color': '#f8f8ff',
    'error': '#ff5959'
  },
  'enphase-ToastMessage': {
    'box-shadow': 'rgb(74, 74, 74, 0.3)',
    border: 'rgb(74, 74, 74, 0.1)',
    'text-color': '#ffffff',
    warning: '#ff8b00',
    error: '#ff5959',
    success: '#13c333',
    info: '#007aff',
    'icon-color': '#ffffff'
  },
  'enphase-Tooltip': {
    'background-color': '#000000',
    error: '#ff5959',
    'text-color': '#ffffff'
  },
  'enphase-TopBar': {
    'box-shadow': 'rgb(74, 74, 74, 0.3)',
    border: 'rgb(74, 74, 74, 0.1)',
    'background-color': 'rgb(38, 38, 39)',
    'dropdown-background-color': 'rgb(38, 38, 39)',
    'dropdown-item-hover': 'rgba(1, 180, 222,0.5)',
    primary: 'rgb(1, 180, 222)',
    secondary: '#ffffff',
    'icon-color': '#ffffff',
    'text-color': '#f4f4f4',
    'alternative-text-color': '#ffffff',
    'default-text-color': 'rgb(1, 180, 222)',
    'indropzone-text-color': 'rgb(255,255,255,0.9)'
  },
  'enphase-Typography': {
    'text-color': '#fff'
  },
  'enphase-UploadFile': {
    primary: 'rgb(1, 180, 222)',
    border: '#b6b6b6',
    'text-color': '#fff',
    'retry-button-border': '#c7c8ca',
    'dropzone-background-color': 'rgba(0,0,0,0.9)',
    'dropzone-border': '#c7c8ca',
    error: 'rgb(1, 180, 222)',
    'indropzone-text-color': 'rgba(0,0,0,0.9)'
  },
  'enphase-scrollbar': {
    'track-color': '#000',
    'thumb-color': 'rgb(38, 38,39)'
  },
  'background-color': 'rgb(38, 38,39)',
  'enphase-TopPane': {
    'text-color': '#fff'
  }
};
exports.default = _default;